<template>
    <div class="page">
        <div class="vw-header">
            <div class="vw-header-left">
                <iframe width="400" scrolling="no" height="25" frameborder="0" allowtransparency="true" src="https://i.tianqi.com?c=code&py=shanghe&id=5&color=%2300B0F0&icon=1&site=15"></iframe>
            </div>
            <div class="vw-header-center">乡村振兴数字三农</div>
            <div class="vw-header-right">{{ nowDate }}</div>
            <div class="head-c-btn" @click="hideWindow" v-if="btnText">
                <eye-invisible-outlined/>
            </div>
            <div class="head-c-btn" @click="hideWindow" v-else>
                <eye-outlined/>
            </div>
            <div class="head-c-btn head-l-btn" @click="logout">
                <logout-outlined/>
            </div>
        </div>
        <div class="vs-map-container" id="vsMapContainer"></div>
        <left :style="leftWindowBox"></left>
        <right :style="rightWindowBox"></right>
        <div class="legend" :style="leftLegendBox">
            <a-space direction="vertical">
                <div @click="dragonCheck(!this.checkStatus.dragon)" class="legend-btn legend-btn-2" :class="{'legend-btn-un': !this.checkStatus.dragon}">龙头企业</div>
                <!--                <div @click="parkCheck(!this.checkStatus.park)" class="legend-btn legend-btn-3" :class="{'legend-btn-un': !this.checkStatus.park}">产业园区</div>-->
                <div @click="cooperativesCheck(!this.checkStatus.cooperatives)" class="legend-btn legend-btn-4" :class="{'legend-btn-un': !this.checkStatus.cooperatives}">合作社</div>
                <div @click="homesCheck(!this.checkStatus.homes)" class="legend-btn legend-btn-5" :class="{'legend-btn-un': !this.checkStatus.homes}">家庭农场</div>
                <div @click="servicesCheck(!this.checkStatus.services)" class="legend-btn legend-btn-1" :class="{'legend-btn-un': !this.checkStatus.services}">服务组织</div>
                <div @click="informationCheck(!this.checkStatus.information)" class="legend-btn legend-btn-0" :class="{'legend-btn-un': !this.checkStatus.information}">益农信息社</div>
            </a-space>
        </div>
        <a-button class="return-btn" @click="handleReturn">返回</a-button>
        <div class="count-num" v-show="countNumVisible">
<!--            <div class="count-block"><p>{{ countNum.dragon }}</p><span>龙头企业</span></div>-->
<!--            <div class="count-block"><p>{{ countNum.cooperatives }}</p><span>合作社</span></div>-->
<!--            <div class="count-block"><p>{{ countNum.homes }}</p><span>家庭农场</span></div>-->
<!--            <div class="count-block"><p>{{ countNum.services }}</p><span>服务组织</span></div>-->
<!--            <div class="count-block"><p>{{ countNum.information }}</p><span>益农信息社</span></div>-->

            <div class="count-block"><p>66</p><span>龙头企业</span></div>
            <div class="count-block"><p>1798</p><span>合作社</span></div>
            <div class="count-block"><p>1826</p><span>家庭农场</span></div>
            <div class="count-block"><p>503</p><span>服务组织</span></div>
            <div class="count-block"><p>{{ countNum.information }}</p><span>益农信息社</span></div>
        </div>
    </div>
    <infoBox
        ref="infoBoxRef"
        @cancel="() => infoBoxVisible = false"
        v-if="infoBoxVisible"
    ></infoBox>
    <infoBoxForPark
        ref="infoBoxForParkRef"
        @cancel="() => infoBoxForParkVisible = false"
        v-if="infoBoxForParkVisible"
    ></infoBoxForPark>
    <infoBoxForHouse
        ref="infoBoxForHouseRef"
        @cancel="() => infoBoxForHouseVisible = false"
        v-if="infoBoxForHouseVisible"
    ></infoBoxForHouse>
    <searchBox :style="rightSearch"></searchBox>
</template>

<script>
import {notification} from "ant-design-vue"

const wmtsCode = {
    '5162': 'yinxiang', // 殷巷镇
    '5163': 'huairen', // 怀仁镇
    '5164': 'longsangsi', // 龙桑寺镇
    '5165': 'zhenglu', // 郑路镇
    '5166': 'jiazhuang', // 贾庄镇
    '5167': 'yuhuangmiao', // 玉皇庙镇
    '5168': 'baiqiao', // 白桥镇
    '5169': 'sunji', // 孙集镇
    '5170': 'hanmiao', // 韩庙镇
    '5171': 'shahe', // 沙河镇
    '5172': 'zhangfang', // 张坊镇
    '6048': 'xushang', // 许商街道
    '0': 'shanghequanxian' // 许商街道
}
import {getCesiumGeoJson} from "@/gisConfig/getGeoJson"
import {ref} from 'vue'
import {useRouter} from "vue-router"
import left from "../../components/gis/left"
import right from "../../components/gis/right"
import infoBox from "@/views/gis/components/infoBox"
import infoBoxForPark from "@/views/gis/components/infoBoxForPark"
import infoBoxForHouse from "@/views/gis/components/infoBoxForHouse"
import searchBox from "@/components/gis/searchBox"
import {getGreenhouseApi, getGreenhouseDetailsApi, getQueryAllDataApi, getQueryByIdForInformationApi, getQueryByIdForMultipleApi, getQueryByIdForParkApi} from "@/api/visualization"
import {EyeOutlined, EyeInvisibleOutlined, LogoutOutlined} from '@ant-design/icons-vue'

const url = 'https://shysai.innomesh.cn:6444/'
let enterView
const icon0 = require('@/assets/img/icon_cooperatives.png')
const icon1 = require('@/assets/img/icon_homes.png')
const icon2 = require('@/assets/img/icon_services_r.png')
const icon3 = require('@/assets/img/icon_informations.png')
const icon4 = require('@/assets/img/icon_park.png')
const icon5 = require('@/assets/img/icon_dargon.png')
const icon6 = require('@/assets/img/greenhouse.png')
const flag = require('@/assets/img/flag.png')
import Cookies from "js-cookie"
import router from "@/router"

export default {
    /* eslint-disable */
    name: "Visualization",
    setup() {
        const style = ref({})
        const viewer = ref({})
        const nowDate = ref('')
        const bodyIndex = ref(0)
        const allDeviceIdList = ref([])
        const bodyApiData = ref([])
        const leftWindowBox = ref({})
        const rightWindowBox = ref({})
        const rightSearch = ref({})
        const leftLegendBox = ref({})
        const infoBoxVisible = ref(false)
        const infoBoxForParkVisible = ref(false)
        const infoBoxForHouseVisible = ref(false)
        const btnText = ref(false)
        const countNum = ref({
            cooperatives: 0,
            homes: 0,
            services: 0,
            information: 0,
            dragon: 0
        })
        const bodyList = ref({
            cooperatives: [],
            homes: [],
            services: [],
            park: [],
            information: [],
            dragon: []
        })
        const bodyData = ref({
            cooperatives: [],
            homes: [],
            services: [],
            park: [],
            informationHouse: [],
            dragonHead: []
        })
        const router = useRouter()
        const greenhouseData = ref([])
        const checkStatus = ref({
            dragon: false,
            park: false,
            cooperatives: false,
            homes: false,
            services: false,
            information: false
        })
        const townId = Cookies.get('userInfo') ? JSON.parse(Cookies.get('userInfo')).townid : null
        const countNumVisible = ref(true)
        return {
            style,
            viewer,
            nowDate,
            router,
            bodyData,
            bodyIndex,
            allDeviceIdList,
            bodyList,
            bodyApiData,
            infoBoxVisible,
            infoBoxForParkVisible,
            infoBoxForHouseVisible,
            leftWindowBox,
            rightWindowBox,
            rightSearch,
            btnText,
            leftLegendBox,
            checkStatus,
            greenhouseData,
            townId,
            countNum,
            countNumVisible,
            icon0,
            icon1,
            icon2,
            icon3,
            icon4,
            icon5,
            icon6,
            wmtsCode
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.currentTime()
            setTimeout(() => {
                this.initGlobe()
            }, 200)
        })
    },
    methods: {
        initGlobe() {
            // cesium 初始化
            const viewer = new Cesium.Map('vsMapContainer', {
                // imageryProvider: mapSingle,
                shouldAnimate: true,
                selectionIndicator: true,
                infoBox: false,
                orderIndependentTranslucency: false,
                contextOptions: {
                    webgl: {
                        alpha: true,
                    }
                },
            })
            viewer.scene.skyBox.show = false
            viewer.scene.backgroundColor = Cesium.Color.TRANSPARENT
            viewer.scene.globe.baseColor = Cesium.Color.TRANSPARENT
            // 抗锯齿
            viewer.scene.postProcessStages.fxaa.enabled = false
            // 水雾特效
            viewer.scene.globe.showGroundAtmosphere = true
            // 设置最大俯仰角，[-90,0]区间内，默认为-30，单位弧度
            viewer.scene.screenSpaceCameraController.constrainedPitch = Cesium.Math.toRadians(-20)
            // viewer.scene.screenSpaceCameraController.minimumZoomDistance = 2500// 相机的高度的最小值， 一般不需要设置
            viewer.scene.screenSpaceCameraController.maximumZoomDistance = 130000  // 相机高度的最大值
            // 取消默认的双击事件
            viewer.cesiumWidget.screenSpaceEventHandler.removeInputAction(Cesium.ScreenSpaceEventType.LEFT_DOUBLE_CLICK)
            // 叠加影像服务
            this.viewer = viewer
            //监控相机高度
            this.onZoom()
            this.getClickInfo()
            this.initMapData()
        },
        getClickInfo() {
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const that = this
            const handler = new Cesium.ScreenSpaceEventHandler(that.viewer.scene.canvas)
            handler.setInputAction(function (movement) {
                // eslint-disable-next-line no-unused-vars
                let clickLon = null
                // eslint-disable-next-line no-unused-vars
                let clickLat = null
                const scene = that.viewer.scene
                const pickedObject = scene.pick(movement.position) //判断是否拾取到模型
                if (scene.pickPositionSupported && Cesium.defined(pickedObject)) {
                    const cartesian = that.viewer.scene.pickPosition(movement.position)
                    if (Cesium.defined(cartesian)) {
                        const cartographic = Cesium.Cartographic.fromCartesian(cartesian) //根据笛卡尔坐标获取到弧度
                        const lng = Cesium.Math.toDegrees(cartographic.longitude) //根据弧度获取到经度
                        const lat = Cesium.Math.toDegrees(cartographic.latitude) //根据弧度获取到纬度
                        // let height = cartographic.height//模型高度
                        clickLon = lng
                        clickLat = lat
                    }
                }
                const pick = that.viewer.scene.pick(movement.position)
                if (Cesium.defined(pick) && pick.id._type) {
                    if (pick.id._ident) {
                        that.showBodyInfoWindow(pick.id._ident, pick.id._type)
                    }
                }
                if (Cesium.defined(pick) && pick.id._opCenterName) {
                    if (that.townId === '0') {
                        that.townMoveCamera(pick.id._townId)
                    }
                }
            }, Cesium.ScreenSpaceEventType.LEFT_CLICK)
        },
        initMapData() {
            this.setWMTS() //设置影像图
            if (this.townId === '0') {
                this.setInitPipe()
                this.initOTCenter()
            }
            this.setMapData()
        },
        async setMapData() {
            const id = this.townId !== '0' ? this.townId : '0'
            const res = await getQueryAllDataApi(id)
            this.bodyData.cooperatives = res[0].合作社
            this.bodyData.homes = res[0].家庭农场
            this.bodyData.services = res[0].服务组织
            this.bodyData.park = res[0].产业园区
            this.bodyData.informationHouse = res[0].益农信息社
            this.bodyData.dragonHead = res[0].龙头企业
            this.countNum.cooperatives = res[0].合作社.length
            this.countNum.homes = res[0].家庭农场.length
            this.countNum.services = res[0].服务组织.length
            this.countNum.information = res[0].益农信息社.length
            this.countNum.dragon = res[0].龙头企业.length
            const greenhouse = await getGreenhouseApi(id)
            const greenhouseData = []
            if (greenhouse) {
                for (const i in greenhouse) {
                    if (greenhouse[i].id !== '31886268029291') {
                        greenhouseData.push({name: greenhouse[i].greenhouseName, id: greenhouse[i].id, coordinate: greenhouse[i].greenhouseCoordinate})
                    }
                }
            }
            this.greenhouseData = greenhouseData
            this.setCameraPosition()
        },
        showBodyInfoWindow(id, type) {
            if (type === 'cooperatives' || type === 'homes' || type === 'services' || type === 'dragon') {
                // 合作社、家庭农场、服务组织、龙头企业
                getQueryByIdForMultipleApi(id).then((res) => {
                    this.infoBoxVisible = true
                    this.$nextTick(() => {
                        this.$refs.infoBoxRef.setData(res, type)
                    })
                })
            } else if (type === 'information') {
                // 益农信息社
                getQueryByIdForInformationApi(id).then((res) => {
                    this.infoBoxVisible = true
                    this.$nextTick(() => {
                        this.$refs.infoBoxRef.setData(res, type)
                    })
                })
            } else if (type === 'park') {
                // 产业园区
                getQueryByIdForParkApi(id).then((res) => {
                    this.infoBoxForParkVisible = true
                    this.$nextTick(() => {
                        this.$refs.infoBoxForParkRef.setData(res)
                    })
                })
            } else if (type === 'greenhouse') {
                // 大棚
                getGreenhouseDetailsApi(id).then((res) => {
                    this.infoBoxForHouseVisible = true
                    this.$nextTick(() => {
                        this.$refs.infoBoxForHouseRef.setData(res)
                    })
                })
            }
        },
        setDeviceFeature(data, type, color, icon, typeText) {
            let inIcon = ''
            for (const index in data) {
                this.bodyIndex++
                if (data[index].coordinate) {
                    const lon = parseFloat(data[index].coordinate.split(',')[0])
                    const lat = parseFloat(data[index].coordinate.split(',')[1])
                    if (!lon || !lat) {
                        continue
                    }
                    if (data[index].coordinateflag) {
                        inIcon = flag
                    } else {
                        inIcon = icon
                    }
                    const model = {
                        bodyId: type + '_' + this.bodyIndex,
                        type: type,
                        name: data[index].name,
                        typeText: typeText,
                        textColor: "color:" + color,
                        ident: data[index].id,
                        id: type + '_' + this.bodyIndex,
                        position: Cesium.Cartesian3.fromDegrees(lon, lat),
                        billboard: {
                            image: inIcon,
                            width: 30,
                            height: 37.5,
                            eyeOffset: new Cesium.Cartesian3(0, 0, -20),
                            pixelOffset: new Cesium.Cartesian2(0, -40)
                        }
                    }
                    this.viewer.entities.add(model)
                    this.allDeviceIdList.push(type + '_' + this.bodyIndex)
                    switch (type) {
                        case 'cooperatives':
                            this.bodyList.cooperatives.push('cooperatives_' + this.bodyIndex)
                            break
                        case 'homes':
                            this.bodyList.homes.push('homes_' + this.bodyIndex)
                            break
                        case 'services':
                            this.bodyList.services.push('services_' + this.bodyIndex)
                            break
                        case 'park':
                            this.bodyList.park.push('park_' + this.bodyIndex)
                            break
                        case 'information':
                            this.bodyList.information.push('information_' + this.bodyIndex)
                            break
                        case 'dragon':
                            this.bodyList.dragon.push('dragon_' + this.bodyIndex)
                            break
                    }
                }
            }
        },
        setWMTS() {
            this.viewer.scene.skyAtmosphere.show = false //隐藏大气圈
            // 叠加影像服务
            const arcGisMSIP = new Cesium.ArcGisMapServerImageryProvider({
                url: url + 'arcgis/rest/services/' + wmtsCode[this.townId] + '/MapServer'
            })
            const imageryLayer = new Cesium.ImageryLayer(arcGisMSIP, {
                // show: true,//是否可见
                // alpha: 1//透明度
            })
            this.viewer.imageryLayers.raiseToTop(imageryLayer)
            this.viewer.imageryLayers.add(imageryLayer)
        },
        setCameraPosition() {
            const SHLonLat = {
                lon: 117.42,
                lat: 36.45,
                height: 100000
            }
            const townLonLat = {
                '5162': {lon: 117.17, lat: 37.28, height: 14000}, // 殷巷镇
                '5163': {lon: 117.08, lat: 37.28, height: 14000}, // 怀仁镇
                '5164': {lon: 117.3655, lat: 37.26, height: 12000}, // 龙桑寺镇
                '5165': {lon: 117.36, lat: 37.14, height: 14000}, // 郑路镇
                '5166': {lon: 117.10, lat: 37.17, height: 14000}, // 贾庄镇
                '5167': {lon: 117.155, lat: 37.06, height: 14000}, // 玉皇庙镇
                '5168': {lon: 117.305, lat: 37.08, height: 14000}, // 白桥镇
                '5169': {lon: 117.28, lat: 37.17, height: 14000}, // 孙集镇
                '5170': {lon: 117.28, lat: 37.35, height: 14000}, // 韩庙镇
                '5171': {lon: 117.30, lat: 37.28, height: 14000},  // 沙河镇
                '5172': {lon: 117.11, lat: 37.24, height: 12000}, // 张坊镇
                '6048': {lon: 117.20, lat: 37.15, height: 14000}  // 许商街道
            }
            // 将三维球定位到商河
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const that = this
            if (this.townId !== '0') {
                // 将三维球定位到镇
                this.viewer.camera.flyTo({
                    destination: Cesium.Cartesian3.fromDegrees(townLonLat[this.townId].lon, townLonLat[this.townId].lat, townLonLat[this.townId].height),
                    orientation: {
                        heading: Cesium.Math.toRadians(348.4202942851978),
                        pitch: Cesium.Math.toRadians(-45),
                        roll: Cesium.Math.toRadians(0)
                    },
                    complete: function callback() {
                        that.get3DTiles()
                        that.handlePoints()
                    }
                })
            } else {
                this.viewer.camera.flyTo({
                    destination: Cesium.Cartesian3.fromDegrees(SHLonLat.lon, SHLonLat.lat, SHLonLat.height),
                    orientation: {
                        heading: Cesium.Math.toRadians(348.4202942851978),
                        // pitch : Cesium.Math.toRadians(-89.74026687972041),
                        pitch: Cesium.Math.toRadians(-45),
                        roll: Cesium.Math.toRadians(0)
                    },
                    complete: function callback() {
                        // 定位完成之后的回调函数
                        that.get3DTiles()
                    }
                })
            }
        },
        moveCamera(params) {
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const that = this
            this.viewer.camera.flyTo({
                destination: Cesium.Cartesian3.fromDegrees(params.lon, params.lat, params.height),
                orientation: {
                    heading: Cesium.Math.toRadians(348.4202942851978),
                    pitch: Cesium.Math.toRadians(-90),
                    roll: Cesium.Math.toRadians(0)
                },
                complete: function callback() {
                    that.handlePoints()
                }
            })
        },
        setInitPipe() {
            const sideGeoJson = getCesiumGeoJson()
            // 初始化状态
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const that = this
            // const colors = ['#6262F4','#4141B1','#25257A','#25257A','#6262F4','#25257A','#4141B1','#6262F4','#25257A','#6262F4','#4141B1','#25257A',]
            const colors = ['#134554', '#0e3a4b', '#0d4359', '#0d4359', '#0f506a', '#0b4e68', '#085675', '#034965', '#055a7b', '#056287', '#056c95', '#04729d']
            Cesium.Math.setRandomNumberSeed(0)  //设置随机数种子
            const promise = Cesium.GeoJsonDataSource.load(sideGeoJson) //geojson面数据
            promise.then(function (dataSource) {
                that.viewer.dataSources.add(dataSource).then(res => {
                    enterView = res
                })
                const entities = dataSource.entities.values
                const colorHash = {}
                for (let i = 0; i < entities.length; i++) {
                    const entity = entities[i]
                    const name = entity.name + i //geojson里面必须得有一个name属性，entity.name对应
                    let color = colorHash[name] //可以使两个同名要素使用同一种颜色。。。
                    if (!color) {
                        color = new Cesium.Color.fromCssColorString(colors[i])
                        colorHash[name] = color
                    }
                    entity.polygon.material = color
                    entity.polygon.outline = false
                    // entity.polygon.extrudedHeight = Math.floor(Math.random()*4000+2000) //20000~60000的随机数，单位是米
                    entity.polygon.extrudedHeight = -400
                }
            })
        },
        cooperativesCheck(e) {
            this.checkStatus.cooperatives = e
            if (e) {
                if (this.bodyList.cooperatives.length === 0) {
                    this.setDeviceFeature(this.bodyData.cooperatives, 'cooperatives', '#2a56ab', icon0, '合作社') // 合作社
                } else {
                    for (const i in this.bodyList.cooperatives) {
                        this.viewer.entities.getById(this.bodyList.cooperatives[i]).show = true
                    }
                }
            } else {
                if (this.bodyList.cooperatives.length > 0) {
                    for (const i in this.bodyList.cooperatives) {
                        this.viewer.entities.getById(this.bodyList.cooperatives[i]).show = false
                    }
                }
            }
        },
        homesCheck(e) {
            this.checkStatus.homes = e
            if (e) {
                if (this.bodyList.homes.length === 0) {
                    this.setDeviceFeature(this.bodyData.homes, 'homes', '#4b8734', icon1, '家庭农场') // 家庭农场
                } else {
                    for (const i in this.bodyList.homes) {
                        this.viewer.entities.getById(this.bodyList.homes[i]).show = true
                    }
                }
            } else {
                if (this.bodyList.homes.length > 0) {
                    for (const i in this.bodyList.homes) {
                        this.viewer.entities.getById(this.bodyList.homes[i]).show = false
                    }
                }
            }
        },
        servicesCheck(e) {
            this.checkStatus.services = e
            if (e) {
                if (this.bodyList.services.length === 0) {
                    this.setDeviceFeature(this.bodyData.services, 'services', '#a4742d', icon2, '服务组织') // 服务组织
                } else {
                    for (const i in this.bodyList.services) {
                        this.viewer.entities.getById(this.bodyList.services[i]).show = true
                    }
                }
            } else {
                if (this.bodyList.services.length > 0) {
                    for (const i in this.bodyList.services) {
                        this.viewer.entities.getById(this.bodyList.services[i]).show = false
                    }
                }
            }
        },
        // parkCheck(e) {
        //     this.checkStatus.park = e
        //     if (e) {
        //         this.setDeviceFeature(this.bodyData.park, 'park', '#b97c32', icon4, '产业园区') // 产业园区
        //     } else {
        //         if (this.bodyList.park.length > 0) {
        //             for (const i in this.bodyList.park) {
        //                 this.viewer.entities.remove(this.viewer.entities.getById(this.bodyList.park[i]))
        //             }
        //             this.bodyList.park = []
        //         }
        //     }
        // },
        informationCheck(e) {
            this.checkStatus.information = e
            if (e) {
                if (this.bodyList.information.length === 0) {
                    this.setDeviceFeature(this.bodyData.informationHouse, 'information', '#51afb8', icon3, '益农信息社') // 益农信息社
                } else {
                    for (const i in this.bodyList.information) {
                        this.viewer.entities.getById(this.bodyList.information[i]).show = true
                    }
                }
            } else {
                if (this.bodyList.information.length > 0) {
                    for (const i in this.bodyList.information) {
                        this.viewer.entities.getById(this.bodyList.information[i]).show = false
                    }
                }
            }
        },
        dragonCheck(e) {
            this.checkStatus.dragon = e
            if (e) {
                if (this.bodyList.dragon.length === 0) {
                    this.setDeviceFeature(this.bodyData.dragonHead, 'dragon', '#9e352b', icon5, '龙头企业') // 龙头企业
                } else {
                    for (const i in this.bodyList.dragon) {
                        this.viewer.entities.getById(this.bodyList.dragon[i]).show = true
                    }
                }
                if (this.bodyList.park.length === 0) {
                    this.setDeviceFeature(this.bodyData.park, 'park', '#9e352b', icon5, '产业园区') // 产业园区
                } else {
                    for (const i in this.bodyList.park) {
                        this.viewer.entities.getById(this.bodyList.park[i]).show = true
                    }
                }
            } else {
                if (this.bodyList.dragon.length > 0) {
                    for (const i in this.bodyList.dragon) {
                        this.viewer.entities.getById(this.bodyList.dragon[i]).show = false
                    }
                }
                if (this.bodyList.park.length > 0) {
                    for (const i in this.bodyList.park) {
                        this.viewer.entities.getById(this.bodyList.park[i]).show = false
                    }
                }
            }
        },
        onZoom() {
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const that = this
            const handler = new Cesium.ScreenSpaceEventHandler(that.viewer.scene.canvas)
            handler.setInputAction(function () {
                const height = Math.ceil(that.viewer.camera.positionCartographic.height)
                that.countNumVisible = true
                if (that.townId === '0') {
                    if (height >= 15001) {
                        if (!enterView) {
                            that.setInitPipe() // 初始化图层
                        }
                        if (that.allDeviceIdList.length > 0) {
                            for (const i in that.allDeviceIdList) {
                                that.viewer.entities.getById(that.allDeviceIdList[i]).show = false
                                // that.viewer.entities.remove(that.viewer.entities.getById(that.allDeviceIdList[i]))
                            }
                            // that.allDeviceIdList = []
                        }
                    }
                }
                if (height < 15000 && height > 1201) {
                    that.countNumVisible = false
                    if (height < 15000 && height > 4000) {
                        if (that.townId === '0') {
                            that.handlePoints()
                        }
                    }
                } else if (height < 1200) {
                    that.countNumVisible = false
                }
            }, Cesium.ScreenSpaceEventType.WHEEL)
        },
        handlePoints() {
            if (enterView) {
                this.viewer.dataSources.remove(enterView) // 清除初始化图层
                enterView = null
            }
            // if (this.allDeviceIdList.length === 0) {
            if (this.checkStatus.cooperatives) {
                if (this.bodyList.cooperatives.length === 0) {
                    this.setDeviceFeature(this.bodyData.cooperatives, 'cooperatives', '#2a56ab', icon0, '合作社') // 合作社
                } else {
                    for (const i in this.bodyList.cooperatives) {
                        this.viewer.entities.getById(this.bodyList.cooperatives[i]).show = true
                    }
                }
            }
            if (this.checkStatus.homes) {
                if (this.bodyList.homes.length === 0) {
                    this.setDeviceFeature(this.bodyData.homes, 'homes', '#4b8734', icon1, '家庭农场') // 家庭农场
                } else {
                    for (const i in this.bodyList.homes) {
                        this.viewer.entities.getById(this.bodyList.homes[i]).show = true
                    }
                }
            }
            if (this.checkStatus.services) {
                if (this.bodyList.services.length === 0) {
                    this.setDeviceFeature(this.bodyData.services, 'services', '#a4742d', icon2, '服务组织') // 服务组织
                } else {
                    for (const i in this.bodyList.services) {
                        this.viewer.entities.getById(this.bodyList.services[i]).show = true
                    }
                }
            }
            // if (this.checkStatus.park) {
            //     this.setDeviceFeature(this.bodyData.park, 'park', '#b97c32', icon4, '产业园区') // 产业园区
            // }
            if (this.checkStatus.information) {
                if (this.bodyList.information.length === 0) {
                    this.setDeviceFeature(this.bodyData.informationHouse, 'information', '#51afb8', icon3, '益农信息社') // 益农信息社
                } else {
                    for (const i in this.bodyList.information) {
                        this.viewer.entities.getById(this.bodyList.information[i]).show = true
                    }
                }
            }
            if (this.checkStatus.dragon) {
                if (this.bodyList.dragon.length === 0) {
                    this.setDeviceFeature(this.bodyData.dragonHead, 'dragon', '#9e352b', icon5, '龙头企业') // 龙头企业
                } else {
                    for (const i in this.bodyList.dragon) {
                        this.viewer.entities.getById(this.bodyList.dragon[i]).show = true
                    }
                }
                if (this.bodyList.park.length === 0) {
                    this.setDeviceFeature(this.bodyData.park, 'park', '#9e352b', icon5, '产业园区') // 产业园区
                } else {
                    for (const i in this.bodyList.park) {
                        this.viewer.entities.getById(this.bodyList.park[i]).show = true
                    }
                }
            }
            this.setDeviceFeature(this.greenhouseData, 'greenhouse', '#65b7e5', icon6, '大棚') // 大棚
            // }
        },
        currentTime() {
            setInterval(this.formatDate, 500)
        },
        formatDate() {
            const date = new Date()
            const year = date.getFullYear() // 年
            const month = date.getMonth() + 1 // 月
            const day = date.getDate() // 日
            const week = date.getDay() // 星期
            const weekArr = ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"]
            let hour = date.getHours() // 时
            hour = hour < 10 ? "0" + hour : hour // 如果只有一位，则前面补零
            let minute = date.getMinutes() // 分
            minute = minute < 10 ? "0" + minute : minute // 如果只有一位，则前面补零
            let second = date.getSeconds() // 秒
            second = second < 10 ? "0" + second : second // 如果只有一位，则前面补零
            this.nowDate = `${year}/${month}/${day} ${hour}:${minute}:${second} ${weekArr[week]}`
        },
        handleReturn() {
            this.router.back(-1)
        },
        hideWindow() {
            this.hideSideWindow(this.btnText)
            this.btnText = !this.btnText
        },
        hideSideWindow(v) {
            const width = document.body.clientWidth
            if (v) {
                this.leftWindowBox = {left: '30px'}
                this.rightWindowBox = {right: '30px'}
                if (width > 1920) {
                    this.leftLegendBox = {left: '735px'}
                    this.rightSearch = {right: '735px'}
                } else {
                    this.leftLegendBox = {left: '535px'}
                    this.rightSearch = {right: '535px'}
                }
            } else {
                this.leftWindowBox = {left: '80px'}
                this.rightWindowBox = {right: '80px'}
                if (width > 1920) {
                    this.leftLegendBox = {left: '785px'}
                    this.rightSearch = {right: '785px'}
                } else {
                    this.leftLegendBox = {left: '585px'}
                    this.rightSearch = {right: '585px'}
                }
                setTimeout(() => {
                    this.leftWindowBox = {left: '-710px'}
                    this.rightWindowBox = {right: '-710px'}
                    this.leftLegendBox = {left: '25px'}
                    this.rightSearch = {right: '25px'}
                }, 200)
            }
        },
        get3DTiles() {
            if (this.townId === '0') {
                const names = [
                    'JIAWAHUAHUICHANYEYUAN',
                    'YUGANGXIHONGSHICHANYEYUAN',
                    'JIAZHUANGXIANGCUNLVZHOUZONGBU',
                    'XIANGCUNLVZHOUCHANYEYUAN'
                ]
                const heights = [-84, -60, -78, -59]
                for (let i = 0; i < names.length; i++) {
                    const tileSet = this.viewer.scene.primitives.add(new Cesium.Cesium3DTileset({
                        url: '../Build/cesiumData/3DTile/' + names[i] + '/tileset.json',
                    }))
                    tileSet.readyPromise.then(function (tileSet) {
                        const boundingSphere = tileSet.boundingSphere
                        const cartographic = Cesium.Cartographic.fromCartesian(boundingSphere.center)
                        const surface = Cesium.Cartesian3.fromRadians(cartographic.longitude, cartographic.latitude, 0.0)
                        const offset = Cesium.Cartesian3.fromRadians(cartographic.longitude, cartographic.latitude, heights[i])
                        const translation = Cesium.Cartesian3.subtract(offset, surface, new Cesium.Cartesian3())
                        tileSet.modelMatrix = Cesium.Matrix4.fromTranslation(translation)
                    })
                }
            } else {
                const tiles = {
                    '5166': [{name: 'JIAWAHUAHUICHANYEYUAN', height: -84}, {name: 'JIAZHUANGXIANGCUNLVZHOUZONGBU', height: -78}],
                    '6048': [{name: 'XIANGCUNLVZHOUCHANYEYUAN', height: -59}],
                    '5167': [{name: 'YUGANGXIHONGSHICHANYEYUAN', height: -60}]
                }
                const names = tiles[this.townId]
                if (names) {
                    for (let i = 0; i < names.length; i++) {
                        const tileSet = this.viewer.scene.primitives.add(new Cesium.Cesium3DTileset({
                            url: '../Build/cesiumData/3DTile/' + names[i].name + '/tileset.json',
                        }))
                        tileSet.readyPromise.then(function (tileSet) {
                            const boundingSphere = tileSet.boundingSphere
                            const cartographic = Cesium.Cartographic.fromCartesian(boundingSphere.center)
                            const surface = Cesium.Cartesian3.fromRadians(cartographic.longitude, cartographic.latitude, 0.0)
                            const offset = Cesium.Cartesian3.fromRadians(cartographic.longitude, cartographic.latitude, names[i].height)
                            const translation = Cesium.Cartesian3.subtract(offset, surface, new Cesium.Cartesian3())
                            tileSet.modelMatrix = Cesium.Matrix4.fromTranslation(translation)
                        })
                    }
                }
            }
        },
        initOTCenter() {
            // 初始化运营中心数据
            const townList = this.$utils.townList
            for (const i in townList) {
                const lon = townList[i].lon
                const lat = townList[i].lat
                const model = {
                    opCenterName: townList[i].name,
                    townId: townList[i].id,
                    label: {
                        text: townList[i].name,
                        font: '14pt Source Han Sans CN',
                        eyeOffset: new Cesium.Cartesian3(0, 0, -10),
                        style: Cesium.LabelStyle.FILL_AND_OUTLINE,
                        fillColor: new Cesium.Color.fromCssColorString("#FFFFFF"),
                        outlineColor: new Cesium.Color.fromCssColorString("#1CC8FA"),
                        outlineWidth: 1,
                        horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
                        verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
                    },
                    position: Cesium.Cartesian3.fromDegrees(lon, lat),
                }
                this.viewer.entities.add(model)
            }
        },
        townMoveCamera(clickId) {
            let townLonLat = {
                '5162': {lon: 117.17, lat: 37.28, height: 14000}, // 殷巷镇
                '5163': {lon: 117.08, lat: 37.28, height: 14000}, // 怀仁镇
                '5164': {lon: 117.3655, lat: 37.26, height: 12000}, // 龙桑寺镇
                '5165': {lon: 117.36, lat: 37.14, height: 14000}, // 郑路镇
                '5166': {lon: 117.10, lat: 37.17, height: 14000}, // 贾庄镇
                '5167': {lon: 117.155, lat: 37.06, height: 14000}, // 玉皇庙镇
                '5168': {lon: 117.305, lat: 37.08, height: 14000}, // 白桥镇
                '5169': {lon: 117.28, lat: 37.17, height: 14000}, // 孙集镇
                '5170': {lon: 117.28, lat: 37.35, height: 14000}, // 韩庙镇
                '5171': {lon: 117.30, lat: 37.28, height: 14000},  // 沙河镇
                '5172': {lon: 117.11, lat: 37.24, height: 12000}, // 张坊镇
                '6048': {lon: 117.20, lat: 37.15, height: 14000}  // 许商街道
            }
            // 将三维球定位到镇
            let that = this
            this.viewer.camera.flyTo({
                destination: Cesium.Cartesian3.fromDegrees(townLonLat[clickId].lon, townLonLat[clickId].lat, townLonLat[clickId].height),
                orientation: {
                    heading: Cesium.Math.toRadians(348.4202942851978),
                    pitch: Cesium.Math.toRadians(-45),
                    roll: Cesium.Math.toRadians(0)
                },
                complete: function callback() {
                    // 定位完成之后的回调函数
                    that.handlePoints()
                }
            })
        },
        logout() {
            Cookies.set('Token', null, {expires: 1})
            Cookies.set('userInfo', '', {expires: 1})
            notification.success({message: '已退出!', description: '', duration: 1})
            setTimeout(() => {
                router.push({name: 'adminLogin'})
            }, 1000)
        },
    },
    // 销毁定时器
    beforeUnmount() {
        if (this.formatDate) {
            clearInterval(this.formatDate); // 在Vue实例销毁前，清除时间定时器
        }
        if (this.viewer) {
            this.viewer.destroy()
            this.viewer = undefined
        }
    },
    components: {
        left,
        right,
        infoBox,
        infoBoxForPark,
        infoBoxForHouse,
        searchBox,
        EyeOutlined,
        EyeInvisibleOutlined,
        LogoutOutlined
    }
}
</script>
<style scoped lang="stylus">
.page {
    width 100%
    height 100%
    background-image url("../../assets/img/visualization_bg.png")
    background-size cover
    overflow hidden
    position relative

    .count-num {
        position absolute
        left 50%
        top 112px
        transform translateX(-50%)
        z-index 1
        display flex

        .count-block {
            color #FFF
            font-size 17px
            text-align center
            margin 0 20px
        }

        .count-block p {
            color #00D6E1
            font-size 50px
            font-family LiquidCrystal-Normal
            font-style oblique
        }
    }

    .vw-header {
        width 100%
        height 75px
        position absolute
        left 0
        top 0
        z-index 1
        background #050D28

        .head-l-btn {
            right 40px !important
            font-size 22px !important
            top 19px !important
            color #23cefd !important
            transform rotate(-90deg)
        }

        .head-c-btn {
            position absolute
            right 290px
            top 15px
            font-size 26px
            color #FFF
            cursor pointer
        }

        .vw-header-left {
            height 75px
            width 447px
            line-height 75px
            background-image url("../../assets/img/visualization_header_l.png")
            background-repeat no-repeat
            background-position-x center
            background-position-y center
            position absolute
            top 0
            left 24px
            display flex
            align-items center
            padding-left 20px
        }

        .vw-header-center {
            width 1120px
            height 72px
            line-height 72px
            text-align center
            color #23CEFD
            font-size 48px
            font-family 'PangMenZhengDao'
            background-image url("../../assets/img/visualization_header_c.png")
            background-size 100% 100%
            position absolute
            top 0
            left calc(50% - 560px)
        }

        .vw-header-right {
            height 72px
            line-height 72px
            text-align right
            width 447px
            font-family 'SourceHanSansCN-Bold'
            font-size 16px
            color #23CEFD
            padding-right 50px
            background-image url("../../assets/img/visualization_header_r.png")
            background-repeat no-repeat
            background-position-x center
            background-position-y center
            position absolute
            top 0
            right 24px
        }
    }

    .vs-map-container {
        width 100%
        height 100%
    }

    .legend {
        position absolute
        bottom 25px
        left 535px
        z-index 1
        transition .3s

        .legend-btn {
            text-align center
            font-size 15px
            padding 5px 20px
            color #FFFFFF
            cursor pointer
            //background-image url("../../assets/img/gis_btn_bg.png")
            background-repeat no-repeat
            background-size 100% 100%
            transition .1s
        }

        .legend-btn-0 {
            background-image url("../../assets/img/gis_btn_bg_0.png")
        }

        .legend-btn-1 {
            background-image url("../../assets/img/gis_btn_bg_1.png")
        }

        .legend-btn-2 {
            background-image url("../../assets/img/gis_btn_bg_2.png")
        }

        .legend-btn-3 {
            background-image url("../../assets/img/gis_btn_bg_3.png")
        }

        .legend-btn-4 {
            background-image url("../../assets/img/gis_btn_bg_4.png")
        }

        .legend-btn-5 {
            background-image url("../../assets/img/gis_btn_bg_5.png")
        }

        .legend-btn-un {
            -webkit-filter grayscale(100%)
            -moz-filter grayscale(100%)
            -ms-filter grayscale(100%)
            -o-filter grayscale(100%)
            filter grayscale(100%)
        }
    }

    .return-btn {
        position absolute
        left 30px
        top 83px
        z-index 1
        background #00D6E1
        border-color #00D6E1
        color #0A5E78
        font-size 18px
        box-shadow 0 3px 6px rgba(0, 214, 225, 0.48)
        border-radius 7px
    }
    @media (min-width: 1921px) {
        .legend {
            left 735px
        }
    }
}
</style>
